import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, qs } from '../lib/api';
import type { CustomerRow } from '../lib/types';
import { CustomerForm } from '../components/forms';
import { Button, Input, Loading, Modal, PageHeader, Table } from '../components/ui';

export function CustomersPage() {
  const [q, setQ] = useState('');
  const [inactive, setInactive] = useState(false);
  const [adding, setAdding] = useState(false);
  const navigate = useNavigate();
  const rows = useQuery({
    queryKey: ['customers', q, inactive],
    queryFn: () => api.get<CustomerRow[]>(`/api/customers${qs({ q, includeInactive: inactive ? '1' : undefined })}`),
  });
  return (
    <>
      <PageHeader title="Customers">
        <Input placeholder="Search name, phone, email…" value={q} onChange={(e) => setQ(e.target.value)} className="w-72" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={inactive} onChange={(e) => setInactive(e.target.checked)} /> Show inactive</label>
        <Button onClick={() => setAdding(true)}>New customer</Button>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white">
        {rows.isLoading ? <Loading /> : (
          <Table head={['Name', 'Phone', 'Email', '']} empty={rows.data?.length === 0}>
            {rows.data?.map((c) => (
              <tr key={c.id} className="hover:bg-slate-50">
                <td className="px-3 py-2"><Link className="font-medium text-blue-800 hover:underline" to={`/customers/${c.id}`}>{c.name}</Link></td>
                <td className="px-3 py-2">{c.phone}</td>
                <td className="px-3 py-2">{c.email}</td>
                <td className="px-3 py-2 text-xs text-slate-500">{!c.active && 'inactive'}</td>
              </tr>
            ))}
          </Table>
        )}
      </div>
      {adding && (
        <Modal title="New customer" onClose={() => setAdding(false)}>
          <CustomerForm onSaved={(c) => navigate(`/customers/${c.id}`)} onCancel={() => setAdding(false)} />
        </Modal>
      )}
    </>
  );
}
